module.exports = __webpack_public_path__ + "img/content3.e854abd6.png";